import React from "react";
import { EyeOutlined } from "@ant-design/icons";
import styles from "./JobSwmsV2.module.css";

const CardActionIcon = ({ name }) => {
  switch (name) {
    case "view":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="currentColor" aria-hidden="true">
          <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6-46.8 43.5-78.1 95.4-93 131.1-3.3 7.9-3.3 16.7 0 24.6 14.9 35.7 46.2 87.7 93 131.1 47.1 43.7 111.8 80.6 192.6 80.6s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1-47.1-43.7-111.8-80.6-192.6-80.6zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64-11.5 0-22.3-3-31.7-8.4-1 10.9-.1 22.1 2.9 33.2 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-12.2-45.7-55.5-74.8-101.1-70.8 5.3 9.3 8.4 20.1 8.4 31.7z" />
        </svg>
      );
    case "edit":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" aria-hidden="true">
          <path d="M352.9 21.2L308 66.1 445.9 204 490.8 159.1C504.4 145.6 512 127.2 512 108s-7.6-37.6-21.2-51.1L455.1 21.2C441.6 7.6 423.2 0 404 0s-37.6 7.6-51.1 21.2zM274.1 100L58.9 315.1c-10.7 10.7-18.5 24.1-22.6 38.7L.9 481.6c-2.3 8.3 0 17.3 6.2 23.4s15.1 8.5 23.4 6.2l127.8-35.5c14.6-4.1 27.9-11.8 38.7-22.6L412 237.9 274.1 100z" />
        </svg>
      );
    case "copy":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor" aria-hidden="true">
          <path d="M192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-200.6c0-17.4-7.1-34.1-19.7-46.2L370.6 17.8C358.7 6.4 342.8 0 326.3 0L192 0zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-16-64 0 0 16-192 0 0-256 16 0 0-64-16 0z" />
        </svg>
      );
    case "history":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="currentColor" aria-hidden="true">
          <path d="M288 64c106 0 192 86 192 192S394 448 288 448c-65.2 0-122.9-32.5-157.6-82.3-10.1-14.5-30.1-18-44.6-7.9s-18 30.1-7.9 44.6C124.1 468.6 201 512 288 512 429.4 512 544 397.4 544 256S429.4 0 288 0C202.3 0 126.5 42.1 80 106.7L80 80c0-17.7-14.3-32-32-32S16 62.3 16 80l0 112c0 17.7 14.3 32 32 32l24.6 0c.5 0 1 0 1.5 0l86 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-38.3 0C154.9 102.6 217 64 288 64zm24 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 104c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65 0-94.1z" />
        </svg>
      );
    case "send":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="currentColor" aria-hidden="true">
          <path d="M536.4-26.3c9.8-3.5 20.6-1 28 6.3s9.8 18.2 6.3 28l-178 496.9c-5 13.9-18.1 23.1-32.8 23.1-14.2 0-27-8.6-32.3-21.7l-64.2-158c-4.5-11-2.5-23.6 5.2-32.6l94.5-112.4c5.1-6.1 4.7-15-.9-20.6s-14.6-6-20.6-.9L229.2 276.1c-9.1 7.6-21.6 9.6-32.6 5.2L38.1 216.8c-13.1-5.3-21.7-18.1-21.7-32.3 0-14.7 9.2-27.8 23.1-32.8l496.9-178z" />
        </svg>
      );
    case "approval":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="currentColor" aria-hidden="true">
          <path d="M224 8a120 120 0 1 1 0 240 120 120 0 1 1 0-240zM194.3 304l59.4 0c3.9 0 7.9 .1 11.8 .4-16.2 28.2-25.5 60.8-25.5 95.6 0 41.8 13.4 80.5 36 112L45.7 512C29.3 512 16 498.7 16 482.3 16 383.8 95.8 304 194.3 304zM288 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-48c0-8.8-7.2-16-16-16z" />
        </svg>
      );
    case "delete":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor" aria-hidden="true">
          <path d="M136.7 5.9L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-8.7-26.1C306.9-7.2 294.7-16 280.9-16L167.1-16c-13.8 0-26 8.8-30.4 21.9zM416 144L32 144 53.1 467.1C54.7 492.4 75.7 512 101 512L347 512c25.3 0 46.3-19.6 47.9-44.9L416 144z" />
        </svg>
      );
    case "approved-status":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" aria-hidden="true">
          <path d="M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zM374 145.7c-10.7-7.8-25.7-5.4-33.5 5.3L221.1 315.2 169 263.1c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c5 5 11.8 7.5 18.8 7s13.4-4.1 17.5-9.8L379.3 179.2c7.8-10.7 5.4-25.7-5.3-33.5z" />
        </svg>
      );
    case "draft-status":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" aria-hidden="true">
          <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L368 46.1 465.9 144 490.3 119.6c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L432 177.9 334.1 80 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z" />
        </svg>
      );
    case "pending-status":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" aria-hidden="true">
          <path d="M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" />
        </svg>
      );
    default:
      return null;
  }
};

const SwmsCard = ({ swms, onSendForApproval, onEdit, onDelete, onCancelReroute }) => {
  const getApproverInitials = (name) => {
    const normalizedName = name && typeof name === "string" ? name.trim() : "";
    if (!normalizedName) {
      return "";
    }

    const parts = normalizedName.split(/\s+/).filter(Boolean);
    if (parts.length === 1) {
      return parts[0].slice(0, 2).toUpperCase();
    }

    const firstInitial = parts[0][0] ? parts[0][0].toUpperCase() : "";
    const lastPart = parts[parts.length - 1];
    const lastInitial = lastPart && lastPart[0] ? lastPart[0].toUpperCase() : "";
    return `${firstInitial}${lastInitial}`;
  };

  const formatStatusLabel = (status) => {
    const normalizedStatus = status ? `${status}`.trim() : "DRAFT";
    return normalizedStatus
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const getStatusClass = (status) => {
    const normalizedStatus = status ? status.toUpperCase().replace(/\s+/g, "_") : "DRAFT";

    switch (normalizedStatus) {
      case 'DRAFT':
        return 'draft';
      case 'PENDING_APPROVAL':
        return 'pending';
      case 'APPROVED':
        return 'approved';
      case 'REJECTED':
        return 'rejected';
      default:
        return 'draft';
    }
  };

  const approvalStatus = swms.approval_status ? swms.approval_status : 'DRAFT';
  const displayApprovalStatus = formatStatusLabel(approvalStatus);
  const statusClass = getStatusClass(approvalStatus);
  const normalizedApprovalStatus = approvalStatus ? approvalStatus.toUpperCase().replace(/\s+/g, "_") : 'DRAFT';
  const isApproved = normalizedApprovalStatus === 'APPROVED';
  const isVisible = swms.is_visible === 1;
  const formName = swms.swms_form_name ? swms.swms_form_name : `SWMS ${swms.swms_form_id}`;
  const formId = swms.swms_form_id ? swms.swms_form_id : "ID-0000";
  const siteName = swms.site_name ? swms.site_name : "N/A";
  const createdDate = swms.created_at ? new Date(swms.created_at).toLocaleDateString() : "N/A";
  const createdBy = swms.created_by ? swms.created_by : "N/A";
  const taskItems = Array.isArray(swms.tasks) ? swms.tasks : [];
  const categoryItems = Array.isArray(swms.categories) ? swms.categories : [];
  const associatedTasksCount = taskItems.length;
  const normalizedCategoryTags = categoryItems
    .map((item) => (item && typeof item.name === "string" ? item.name.trim() : ""))
    .filter(Boolean);
  const hasTags = normalizedCategoryTags.length > 0;
  const visibleTags = hasTags ? normalizedCategoryTags.slice(0, 2) : [];
  const extraTagsCount = hasTags && normalizedCategoryTags.length > 2 ? normalizedCategoryTags.length - 2 : 0;
  const hasApprovers = swms.approvers && swms.approvers.length > 0;
  const totalReviewers = hasApprovers ? swms.approvers.length : 0;
  const currentVersion = Number(swms.currentVersion ? swms.currentVersion : 0);
  const statusColor = statusClass === 'approved' ? '#059669' : '#6B7280';
  const visibilityClass = isVisible ? styles.visible : '';
  const toggleActiveClass = isApproved ? styles.active : '';
  const actionItems = [
    { key: 'view', title: 'View SWMS', icon: 'view', variant: 'blue' },
    { key: 'edit', title: 'Edit SWMS', icon: 'edit', variant: 'amber' },
    { key: 'copy', title: 'Copy', icon: 'copy', variant: 'purple' },
    { key: 'history', title: 'Version History', icon: 'history', variant: 'indigo' }
  ];

  const handleActionClick = (actionKey) => {
    if (actionKey === 'send-manager' && onSendForApproval) {
      onSendForApproval(swms);
      return;
    }

    if (actionKey === 'edit' && onEdit) {
      onEdit(swms);
      return;
    }

    if (actionKey === 'delete' && onDelete) {
      onDelete(swms);
      return;
    }

  };

  if (isApproved) {
    actionItems.push({ key: 'send-client', title: 'Send to Client', icon: 'send', variant: 'green' });
  } else if (normalizedApprovalStatus !== 'PENDING_APPROVAL') {
    actionItems.push({ key: 'send-manager', title: 'Send for Manager Approval', icon: 'approval', variant: 'emerald' });
    if (normalizedApprovalStatus === 'DRAFT' && currentVersion === 1) {
      actionItems.push({ key: 'delete', title: 'Delete', icon: 'delete', variant: 'red' });
    }
  }

  let statusIcon = 'draft-status';
  if (isApproved) {
    statusIcon = 'approved-status';
  } else if (normalizedApprovalStatus === 'PENDING_APPROVAL') {
    statusIcon = 'pending-status';
  }

  return (
    <div className={`${styles.card} ${styles[statusClass]}`}>
      <div className={styles.cardHeader}>
        <div className={styles.cardTitle}>
          <h3>{formName}</h3>
          <p className={styles.cardId}>{formId}</p>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "8px", flexShrink: 0 }}>
          <span className={`${styles.statusBadge} ${styles[statusClass]}`}>
            {displayApprovalStatus}
          </span>
          <div className={`${styles.toggleSwitch} ${toggleActiveClass}`} />
        </div>
      </div>

      <div className={`${styles.visibilityStatus} ${visibilityClass}`}>
        <span>Site visibility:</span>
        {isVisible ? (
          <span style={{ fontWeight: '600' }}>
            <EyeOutlined style={{ marginRight: "4px" }} />
            Visible to team
          </span>
        ) : (
          <span style={{ fontStyle: 'italic' }}>
            Available once Approved
          </span>
        )}
      </div>

      <div className={styles.detailsGrid}>
        <div className={styles.detailItem}>
          <span className={styles.detailLabel}>Site</span>
          <span className={styles.detailValue}>{siteName}</span>
        </div>
        <div className={styles.detailItem}>
          <span className={styles.detailLabel}>Created</span>
          <span className={styles.detailValue}>{createdDate}</span>
        </div>
        <div className={styles.detailItem}>
          <span className={styles.detailLabel}>Created By</span>
          <span className={styles.detailValue}>{createdBy}</span>
        </div>
        <div className={styles.detailItem}>
          <span className={styles.detailLabel}>Associated Tasks</span>
          <span className={styles.detailValue}>{associatedTasksCount}</span>
        </div>
      </div>

      {hasTags && (
        <div className={styles.tagContainer}>
          {visibleTags.map((tag, index) => (
            <span key={index} className={styles.tag}>
              {tag}
            </span>
          ))}
          {extraTagsCount > 0 && (
            <span className={styles.tagOverflowBadge} title={`${extraTagsCount} more categories`}>
              +{extraTagsCount}
            </span>
          )}
        </div>
      )}

      {hasApprovers && (
        <div className={styles.approversSection}>
          <span className={styles.approversLabel}>Approvers:</span>
          <div className={styles.approversContainer}>
            {swms.approvers.map((approver, index) => (
              <div
                key={index}
                className={styles.approverAvatar}
                title={approver}
              >
                {getApproverInitials(approver)}
              </div>
            ))}
          </div>
          <span className={`${styles.approversStatus} ${!isApproved ? styles.approversStatusPending : ""}`}>
            {isApproved ? (
              <>
                <span style={{ display: 'inline-flex', width: '16px', height: '16px', marginRight: '4px' }}>
                  <CardActionIcon name="approved-status" />
                </span>
                All approved
              </>
            ) : (
              <>
                <span style={{ display: 'inline-flex', width: '16px', height: '16px', marginRight: '4px' }}>
                  <CardActionIcon name="pending-status" />
                </span>
                Awaiting Review
              </>
            )}
          </span>
        </div>
      )}

      {normalizedApprovalStatus === 'PENDING_APPROVAL' && (
        <div className={styles.pendingApprovalBanner}>
          <p className={styles.pendingApprovalText}>
            Sent to {totalReviewers} reviewers · 0 of {totalReviewers} responded
          </p>
          <button
            type="button"
            className={styles.cancelRerouteButton}
            onClick={() => onCancelReroute && onCancelReroute(swms)}
          >
            Cancel &amp; Re-route
          </button>
        </div>
      )}

      <div className={styles.cardFooter}>
        <div className={styles.actionButtons}>
          {actionItems.map((action) => (
            <button
              key={action.key}
              className={`${styles.actionButton} ${styles[`actionButton${action.variant.charAt(0).toUpperCase()}${action.variant.slice(1)}`]}`}
              title={action.title}
              disabled={action.disabled}
              type="button"
              onClick={() => handleActionClick(action.key)}
            >
              <span className={styles.actionIconWrap}>
                <CardActionIcon name={action.icon} />
              </span>
            </button>
          ))}
        </div>
        <span className={styles.statusText} style={{ color: statusColor }}>
          <span className={styles.statusIconWrap}>
            <CardActionIcon name={statusIcon} />
          </span>
          {displayApprovalStatus}
        </span>
      </div>
    </div>
  );
};

export default SwmsCard;
